import React from 'react';
import './Error.less';

export const Error = ({text}) => {
	return <div className="error">{text}</div>
}
